// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar {
  position: sticky;
  top: 64px; /* height of mobile nav, this value changes according to height of nav (code is in Page.css) */
  z-index: 11;
  background-color: var(--light);
  filter: var(--shadow);
  display: flex;
  flex-direction: column;
  width: 300px;
  height: calc(100vh - 64px);
  padding: 16px;
}

.Sidebar hr {
  border: 0;
  border-top: 1px solid var(--dark);
  margin: 0;
  margin: 16px 0;
  height: 1px;
}

.toggleSidebarBtn {
  display: none !important;
}

.sidebarLink {
  border: 3px solid transparent; /* Invisible border so adding border to currentSidebarLink doesn't shift the buttons */
  margin: 2px 0;
  transition: transform 100ms;
  /* The rest of the sidebarLink styles are inlined in the IconLink component */
}

.currentSidebarLink,
.sidebarLink:hover {
  color: var(--dark);
  background-color: var(--light);
  filter: var(--shadow);
  border-radius: 6px;
  border: 3px solid var(--dark);
}

.sidebarLink:hover {
  transform: scale(1.02);
}

.currentSidebarLink span {
  font-weight: 600;
}

.mobileSidebarSpacer {
  display: none !important;
  height: 64px;
  background-color: var(--light);
}

@media (max-width: 950px) {
  .Sidebar {
    position: fixed !important;
  }
  .mobileSidebarSpacer {
    display: block !important;
  }
  .Sidebar.closed {
    transform: translateX(-300px);
    transition: transform 210ms ease 0s;
  }
  .Sidebar.open {
    transform: translateX(0px);
    transition: transform 210ms ease 0s;
  }
  .toggleSidebarBtn {
    display: block !important;
    position: fixed !important;
    top: 78px;
    left: 15px;
    z-index: 40;
  }
  .toggleSidebarBtn.open {
    transform: translateX(0px);
    transition: transform 100ms ease 100ms;
  }
  .toggleSidebarBtn.closed {
    transform: translateX(-30px);
    transition: transform 100ms ease 0ms;
  }
}

.Sidebar .contactInfoPanel {
  width: 100%;
  padding: 0 1rem;
}

.Sidebar .contactInfoPanel h3 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.Sidebar .contactInfoPanel i {
  margin-right: 10px;
}

.Sidebar .contactInfoPanel p {
  margin-top: 0px;
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/css/Sidebar.css"],"names":[],"mappings":"AAAA;EAEE,gBAAgB;EAChB,SAAS,EAAE,8FAA8F;EACzG,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B,EAAE,sFAAsF;EACrH,aAAa;EACb,2BAA2B;EAC3B,6EAA6E;AAC/E;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;IAC7B,mCAAmC;EACrC;EACA;IACE,0BAA0B;IAC1B,mCAAmC;EACrC;EACA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,sCAAsC;EACxC;EACA;IACE,4BAA4B;IAC5B,oCAAoC;EACtC;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".Sidebar {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 64px; /* height of mobile nav, this value changes according to height of nav (code is in Page.css) */\n  z-index: 11;\n  background-color: var(--light);\n  filter: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  height: calc(100vh - 64px);\n  padding: 16px;\n}\n\n.Sidebar hr {\n  border: 0;\n  border-top: 1px solid var(--dark);\n  margin: 0;\n  margin: 16px 0;\n  height: 1px;\n}\n\n.toggleSidebarBtn {\n  display: none !important;\n}\n\n.sidebarLink {\n  border: 3px solid transparent; /* Invisible border so adding border to currentSidebarLink doesn't shift the buttons */\n  margin: 2px 0;\n  transition: transform 100ms;\n  /* The rest of the sidebarLink styles are inlined in the IconLink component */\n}\n\n.currentSidebarLink,\n.sidebarLink:hover {\n  color: var(--dark);\n  background-color: var(--light);\n  filter: var(--shadow);\n  border-radius: 6px;\n  border: 3px solid var(--dark);\n}\n\n.sidebarLink:hover {\n  transform: scale(1.02);\n}\n\n.currentSidebarLink span {\n  font-weight: 600;\n}\n\n.mobileSidebarSpacer {\n  display: none !important;\n  height: 64px;\n  background-color: var(--light);\n}\n\n@media (max-width: 950px) {\n  .Sidebar {\n    position: fixed !important;\n  }\n  .mobileSidebarSpacer {\n    display: block !important;\n  }\n  .Sidebar.closed {\n    transform: translateX(-300px);\n    transition: transform 210ms ease 0s;\n  }\n  .Sidebar.open {\n    transform: translateX(0px);\n    transition: transform 210ms ease 0s;\n  }\n  .toggleSidebarBtn {\n    display: block !important;\n    position: fixed !important;\n    top: 78px;\n    left: 15px;\n    z-index: 40;\n  }\n  .toggleSidebarBtn.open {\n    transform: translateX(0px);\n    transition: transform 100ms ease 100ms;\n  }\n  .toggleSidebarBtn.closed {\n    transform: translateX(-30px);\n    transition: transform 100ms ease 0ms;\n  }\n}\n\n.Sidebar .contactInfoPanel {\n  width: 100%;\n  padding: 0 1rem;\n}\n\n.Sidebar .contactInfoPanel h3 {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.Sidebar .contactInfoPanel i {\n  margin-right: 10px;\n}\n\n.Sidebar .contactInfoPanel p {\n  margin-top: 0px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
